import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SelectListItem } from '../models/selectlistitem';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SelectService {
  private baseUrl;

  constructor(protected http: HttpClient, @Inject('BASE_URL') baseUrl: string, private authService: AuthService) {
    this.baseUrl = baseUrl + 'api/selectlist';
  }

  private getSL(url: string, ...params): Observable<SelectListItem[]> {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    let URLparams = '';
    let paramsArray: string[][];

    if (params.length) {
      paramsArray = params[0];
      const newURL = new URLSearchParams(paramsArray);
      URLparams = '?' + newURL.toString();
    }

    return this.http.get<SelectListItem[]>(url + URLparams, { headers: header })
  }

  public getEmployeeSL() {
    const url = `${this.baseUrl}/employees`;
    return this.getSL(url);
  }

  public getLanguageSL(onlyActive: boolean = true, lanId: boolean = false) {
    const url = `${this.baseUrl}/language`;
    return this.getSL(url, { onlyActive, lanId });
  }

  public getWeekSL(year: number) {
    const url = `${this.baseUrl}/week`;
    return this.getSL(url, { year });
  }

  public getDemandTypes(): Observable<SelectListItem[]> {
    return of([
      { id: 1, text: 'Vevői' },
      { id: 2, text: 'Belső' },
      { id: 3, text: 'Beszállítói' },
    ]);
  }

  public getTaskGroups(): Observable<SelectListItem[]> {
    const url = `${this.baseUrl}/taskgroup`;
    return this.getSL(url, {});
  }

  public getTasks(chmId): Observable<SelectListItem[]> {
    const url = `${this.baseUrl}/task`;
    return this.getSL(url, { chmId });
  }

  public getTopicResponsible(): Observable<SelectListItem[]> {
    const url = `${this.baseUrl}/topicresponsible`;
    return this.getSL(url);
  }

  public getSelectList(
    endpoint: string,
    ...params
  ): Observable<SelectListItem[]> {
    const url = `${this.baseUrl}/${endpoint}`;
    return this.getSL(url, ...params);
  }
}
